import {
  jsonb,
  pgTable,
  text,
  timestamp,
  uuid,
  index,
} from "drizzle-orm/pg-core";

// ---------------------------------------------------------------------------
// Broadcast Executions — tracks franchise broadcast rollouts
// ---------------------------------------------------------------------------

export const BROADCAST_STATUSES = [
  "pending", "canary", "rolling_10", "rolling_50", "rolling_100",
  "completed", "failed", "rolled_back",
] as const;

export type BroadcastStatus = (typeof BROADCAST_STATUSES)[number];

export const BROADCAST_TENANT_STATUSES = [
  "pending", "snapshot_created", "applied", "failed", "rolled_back",
] as const;

export type BroadcastTenantStatus = (typeof BROADCAST_TENANT_STATUSES)[number];

export const broadcastExecutions = pgTable("broadcast_executions", {
  id: uuid("id").primaryKey().defaultRandom(),
  orgId: uuid("org_id").notNull(),
  status: text("status").notNull().default("pending"),
  scope: text("scope").notNull(), // config, workflows, templates, all
  payload: jsonb("payload").default({}).notNull(),
  initiatedBy: text("initiated_by").notNull(),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  completedAt: timestamp("completed_at", { withTimezone: true }),
}, (table) => [
  index("idx_broadcast_org").on(table.orgId, table.createdAt),
  index("idx_broadcast_status").on(table.status),
]);

export const broadcastTenantEntries = pgTable("broadcast_tenant_entries", {
  id: uuid("id").primaryKey().defaultRandom(),
  broadcastId: uuid("broadcast_id").notNull(),
  tenantId: uuid("tenant_id").notNull(),
  tenantName: text("tenant_name").notNull(),
  status: text("status").notNull().default("pending"),
  snapshotR2Key: text("snapshot_r2_key"),
  appliedAt: timestamp("applied_at", { withTimezone: true }),
  rolledBackAt: timestamp("rolled_back_at", { withTimezone: true }),
  error: text("error"),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
}, (table) => [
  index("idx_broadcast_tenant_broadcast").on(table.broadcastId),
  index("idx_broadcast_tenant_status").on(table.broadcastId, table.status),
]);
